import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Dropzone from 'react-dropzone'
import { authInfo } from '../../actions'
import { uploadImage } from '../../lib/upload'
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import _ from 'lodash';

const propTypes = {
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  overlay: PropTypes.object,
}

const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}

const clientOptions = {
  sessionCache: true
}

const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)

class EditOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      overlay: {
        id: 1,
        altTxt: '',
        category:'',
        width: 1,
        height: 1,
        swatch: '',
        overlayWhite: '',
        overlayBlack: '',
        disabled: true
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    console.log("this.props.overlay ======== ", this.props.overlay)
    if(this.props.overlay !== nextProps.overlay) {
      this.setState({overlay: nextProps.overlay})
    }
    // this.setRequiredParams();
  }
  // setRequiredParams() {
  //   const { overlay } = this.props
  //   const { required } = this.state
  //   Object.keys(required).forEach((paramName) => {
  //     const param = overlay[paramName];
  //     required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
  //   });
  //   this.setState({ required });
  // }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Box';
    nextState.dialogMessage = 'Do you really want to delete this overlay?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  handleChange(e) {
    const nextState = this.state.overlay;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      overlay: nextState,
    });
    // this.setRequiredParams();
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push('/overlays');
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Overlay Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this overlay rate?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.state.overlay);
        break;
      default:
        this.props.onSave(this.state.overlay);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/overlays');
  }
  handleUploadedImage(name, value) {
    const nextState = this.state.overlay;
    _.set(nextState, name, value)
    this.setState({
      overlay: nextState,
      edited: true,
    })
  }
  onDrop(file, bucket, name, handleChangeOption) {
    console.log('FILE', file)
    const { dispatch } = this.props
    console.log('# New file for bucket: ', bucket);
    console.log('# dispatching uploadImage...');
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        console.log('response***', response)
        handleChangeOption({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        //alert(`Image upload failed: ${err}`);
        return '';
      });
  }
  render() {
    const { overlay } = this.state
    console.log('overlay ---> '. overlay )
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      inputStyleLarge: {
        marginRight: '2%',
        width: '50vw',
      }
    };
    return (
      <div>
        <div>
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="Delete"
              primary
              onClick={this.handleDeleteOpen}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <TextField
              floatingLabelText="Overlay ID"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.id}
              name="id"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <br /><br />
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.altTxt}
              name="altTxt"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Category"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.category}
              name="category"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorStyle={{ color: cyan500 }}
            />
            <br /><br />
            <TextField
              floatingLabelText="Width"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.width}
              name="width"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Height"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.height}
              name="height"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <br /><br />
            <TextField
              floatingLabelText="White Overlay URL"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.overlayWhite || ''}
              name="overlayWhite"
              onChange={this.handleChange}
              style={styles.inputStyleLarge}
              errorStyle={{ color: cyan500 }}
            />
            <Dropzone
              ref="dropzone"
              accept="image/jpeg, image/png, image/gif"
              style={dropzoneStyles}
              onDrop={(file) => this.onDrop(file, 'focus-product-images', "overlayWhite", this.handleChange)}
            >Upload White Overlay</Dropzone>
            <br /><br />
            <TextField
              floatingLabelText="Black Overlay URL"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.overlayBlack}
              name="overlayBlack"
              onChange={this.handleChange}
              style={styles.inputStyleLarge}
              errorStyle={{ color: cyan500 }}
            />
            <Dropzone
              ref="dropzone"
              accept="image/jpeg, image/png, image/gif"
              style={dropzoneStyles}
              onDrop={(file) => this.onDrop(file, 'focus-product-images', "overlayBlack", this.handleChange)}
            >Upload Black Overlay</Dropzone>
            <br /><br />
            <TextField
              floatingLabelText="Swatch URL"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.swatch}
              name="swatch"
              onChange={this.handleChange}
              style={styles.inputStyleLarge}
              errorStyle={{ color: cyan500 }}
            />
            <button
              className="filestack-button"
              onClick={(e) => {
                e.preventDefault;
                return client.picker({
                  uploadInBackground: false,
                  onUploadDone: ((res) => {
                    console.log('RES FROM FILESTACK', res);
                    const targetName = 'swatch'
                    const targetValue = res.filesUploaded[0].url
                    this.handleUploadedImage(targetName, targetValue)
                  })
                }).open()
              }}
              style={dropzoneStyles}>
              <p className="filestack-uplaod">UPLOAD SWATCH</p>
            </button>
            <br /><br /><br />
            <Checkbox
              label="Disabled"
              defaultChecked={overlay.disabled}
              name="disabled"
              onCheck={this.handleChange}
              />
        </div>
      </div>
    );
  }
}

EditOverlay.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditOverlay.propTypes = propTypes;

function mapStateToProps(state) {
  return { 

  };
}

export default connect(mapStateToProps)(EditOverlay);



// WEBPACK FOOTER //
// ./src/components/overlays/EditOverlay.js